import { render } from "./EnquiryQuotataions.vue?vue&type=template&id=129dbbbe&scoped=true"
import script from "./EnquiryQuotataions.vue?vue&type=script&lang=js"
export * from "./EnquiryQuotataions.vue?vue&type=script&lang=js"

import "./EnquiryQuotataions.vue?vue&type=style&index=0&id=129dbbbe&scoped=true&lang=css"

import exportComponent from "/home/paiscaler-travelcrmdev/htdocs/travelcrmdev.paiscaler.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-129dbbbe"]])

export default __exports__